import {
    Component
    ,OnInit
    ,OnDestroy
    ,AfterViewInit
    ,ChangeDetectionStrategy
    ,ChangeDetectorRef
    ,ViewChild
    ,HostListener
    ,ElementRef
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { Subject,forkJoin } from 'rxjs';
import * as FileSaver from 'file-saver';
import * as JSZip from 'jszip';  
import * as iconv from 'iconv-lite';  

import {
    CalendarEvent
    ,CalendarEventAction
    ,CalendarEventTimesChangedEvent
    ,CalendarMonthViewBeforeRenderEvent
} from 'angular-calendar';
import {
    startOfDay
    ,endOfDay
    ,subDays
    ,addDays
    ,endOfMonth
    ,isSameDay
    ,isSameMonth
    ,addHours
} from 'date-fns';

import {
    FvmsUtilService
    ,FvmsCommonService
    ,FvmsApiDtgDownloadService
    ,FvmsApiAuthService
} from "src/app/shared/service";

@Component({
    templateUrl: './dtg.download.calendar.component.html'
    ,styleUrls: ["./dtg.download.calendar.component.scss"]
    ,changeDetection: ChangeDetectionStrategy.OnPush
    ,providers: [DatePipe]
})
export class DtgDownloadCalendarComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    viewType:string = "month";
    viewToday:Date = new Date();
    viewDate:Date = new Date();
    viewLocale:string = "ko";
    isOpenActiveDay:boolean = false;
    refresh: Subject<any> = new Subject();
    currentUserInfo:any;

    colors: any = {
        red: {
            primary: '#ad2121'
            ,secondary: '#FAE3E3'
        }
        ,blue: {
            primary: '#1e90ff'
            ,secondary: '#D1E8FF'
        }
        ,yellow: {
            primary: '#e3bc08'
            ,secondary: '#FDF1BA'
        }
    };
    actions: CalendarEventAction[] = [];
    events: CalendarEvent[] = [];
    listDateChecked:any[] = [];
    listCountCarUsed:any[] = [];
    listTxtFile:any[] = [];
    companyInfo:any;
    listCarInfo:any[];
    isCheckedAllCalendar:boolean = false;
    isCheckedAllCar:boolean = false;
    @ViewChild('containerCalendar') containerCalendar:ElementRef;
    heightCalendar:number = 0;
    fileNameZip:string;

    constructor(
        private modalService: NgbModal
        ,private datePipe: DatePipe
        ,private fvmsUtilService:FvmsUtilService
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgDownloadService:FvmsApiDtgDownloadService
        ,private changeDetectorRef:ChangeDetectorRef
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
    }

    ngOnInit() {
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.dtgEid !== companyInfo.dtgEid){
                        this.companyInfo = companyInfo;
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
                this.reloadListCarInfo();
            });
        
        if(this.companyInfo){
            this.reloadListCarInfo();
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        this.changeHeightContainerListRest();
        this.changeDetectorRef.detectChanges();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.changeHeightContainerListRest();
        this.changeDetectorRef.detectChanges();
    }

    changeHeightContainerListRest(){
        let hCard = this.containerCalendar.nativeElement.offsetHeight;
        this.heightCalendar = hCard;
    }

    clickDay({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            // if (
            //     (isSameDay(this.viewDate, date) && this.isOpenActiveDay === true)
            //     || events.length === 0
            // ) {
            //     this.isOpenActiveDay = false;
            // } else {
            //     this.isOpenActiveDay = true;
            //     this.viewDate = date;
            // }
            //this.isOpenActiveDay = false;
            //this.viewDate = date;
            //let dateYmd = this.datePipe.transform(date,"yyyy-MM-dd");
            //this.reloadCountCarUsed(dateYmd);
        }
    }

    handleEvent(action: string, event: CalendarEvent): void {
        // this.modalData = { event, action };
        // this.modal.open(this.modalContent, { size: 'lg' });
    }

    eventTimesChanged({
        event
        ,newStart
        ,newEnd
    }: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        this.handleEvent('Dropped or resized', event);
        this.refresh.next();
    }

    // addEvent(): void {
    //     this.events.push({
    //         title: 'New event'
    //         ,start: startOfDay(new Date())
    //         ,end: endOfDay(new Date())
    //         ,color: this.colors.red
    //         ,draggable: true
    //         ,resizable: {
    //             beforeStart: true
    //             ,afterEnd: true
    //         }
    //     });
    //     this.refresh.next();
    // }

    beforeMonthViewRender(renderEvent: CalendarMonthViewBeforeRenderEvent): void {
        this.listDateChecked = [];
        renderEvent.body.forEach((day) => {
            let dateYmd = this.datePipe.transform(day.date,"yyyy-MM-dd");
            this.listDateChecked[dateYmd] = false;
            //기본 badgeTotal 은 event count 를 표시하도록 되어있음
            //badgeTotal 을 지정일자의 운행차량수로 변경
            day.badgeTotal = day.events.reduce((pre,curr) => {
                return pre + curr.meta.countCarUsed;
            },0);
        });
    }

    parseDate(calendarDate:any){
        if(calendarDate){
            return this.datePipe.transform(calendarDate,"yyyy-MM-dd");
        }else{
            return "";
        }
    }

    async changeDateCheck($event,dateValue){
        //$event.stopPropagation();
        let dateYmd = this.parseDate(dateValue);
        // console.log("changeDateCheck",$event,dateYmd);
        await this.reloadCountCarUsed(dateYmd);
    }

    changeCheckDateAll(isChecked:boolean){
        this.isCheckedAllCalendar = isChecked;
        let dateFrom = new Date(this.viewDate.getTime());
        dateFrom.setDate(1);
        let dateTo = new Date(dateFrom.getTime());
        dateTo.setMonth(dateTo.getMonth()+1);
        dateTo.setDate(dateTo.getDate()-1);
        // console.log("changeCheckDateAll",this.datePipe.transform(dateFrom,"yyyy-MM-dd"),this.datePipe.transform(dateTo,"yyyy-MM-dd"));
        let listPromise = [];
        while(dateFrom.getTime() <= dateTo.getTime()){
            // console.log("changeCheckDateAll",this.datePipe.transform(dateFrom,"yyyy-MM-dd"),this.datePipe.transform(dateTo,"yyyy-MM-dd"));
            let key = this.datePipe.transform(dateFrom,"yyyy-MM-dd");
            this.listDateChecked[key] = this.isCheckedAllCalendar;
            dateFrom.setDate(dateFrom.getDate()+1);
            let promiseCnt = this.reloadCountCarUsed(key);
            listPromise.push(promiseCnt);
        }
        Promise.all(listPromise).then(() => {
            this.changeDetectorRef.detectChanges();
        });
        // for(let key in this.listDateChecked){
        //     this.listDateChecked[key] = this.isCheckedAllCalendar;
        // }
    }

    changeUnCheckDateAll(isChecked:boolean){
        this.isCheckedAllCalendar = isChecked;
        for(let key in this.listDateChecked){
            this.listDateChecked[key] = this.isCheckedAllCalendar;
        }
    }

    changeCheckCarAll(isChecked:boolean){
        this.isCheckedAllCar = isChecked;
        this.listCarInfo.forEach((carInfo,idx) => {
            this.clickCarNo(idx,isChecked);
        });
    }

    clickCarNo(idx:number,isChecked:boolean = false){
        let carInfo = this.listCarInfo[idx];
        if(carInfo.hasOwnProperty("checked") === false){
            carInfo.checked = false;
        }
        carInfo.checked = isChecked;
    }

    reloadListCarInfo(){
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgEid:this.companyInfo?.dtgEid || ""
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
        };
        this.fvmsApiDtgDownloadService.getListCarInfo(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("reloadListCarInfo",apiResponse);
                    if(apiResponse.resultValue){
                        this.listCarInfo = apiResponse.resultValue;
                        this.listCarInfo = this.listCarInfo.map(item => {
                            item.checked = false;
                            return item;
                        });
                        this.changeDetectorRef.detectChanges();
                        console.log("reloadListCarInfo",this.listCarInfo);
                    }
                }
            });
    }

    reloadCountCarUsed(dateYmd:string){
        let promise = new Promise<void>((resolve) => {
            let fromTime = this.fvmsCommonService.getFromTimeReserve();
            let toTime = this.fvmsCommonService.getToTimeReserve();
            let searchInfo = {
                companyId:this.companyInfo?.companyId || 0
                ,dtgTeamId:this.currentUserInfo?.teamId || ""
                ,dtgEid:this.companyInfo?.dtgEid || ""
                ,searchDateFrom:`${dateYmd} ${fromTime}`
                ,searchDateTo:`${dateYmd} ${toTime}`
            };
            this.fvmsApiDtgDownloadService.getCountCarUsed(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        // console.log("reloadCountCarUsed",typeof apiResponse.resultValue);
                        if(typeof apiResponse.resultValue !== undefined){
                            // console.log("result",dateYmd,apiResponse.resultValue);
                            this.listCountCarUsed[dateYmd] = apiResponse.resultValue;
                            this.getCountCarUsed(dateYmd);
                        }
                        this.changeDetectorRef.detectChanges();
                        resolve();
                    }
            });
        });
        return promise;
    }

    getCountCarUsed(ymd){
        if(typeof(this.listCountCarUsed[ymd]) === "undefined"){
            // console.log("getCountCarUsed","-1",ymd,this.listCountCarUsed[ymd]);
            return -1;
        }else{
            // console.log("getCountCarUsed",ymd,this.listCountCarUsed[ymd]);
            return this.listCountCarUsed[ymd];
        }
    }

    callbackDateYmd(e){
        console.log("callbackDate",e);
        this.viewDate = new Date(e);
    }

    checkToday(targetDate:Date){
        return isSameDay(targetDate,this.viewToday);
    }


    clickFileDownload2(){
        let downloadDateArr = [];
        let downloadUnitIdArr = [];
        let self = this;

        // 체크 된 일자만 다운로드
        for(let key in this.listDateChecked){
            if(this.listDateChecked[key]){
                // console.log(key+" : "+this.listDateChecked[key])
                downloadDateArr.push(key);
            }
        }

        // 체크 된 차량만 다운로드
        downloadUnitIdArr = this.listCarInfo
            .filter(car => car.checked)
            .map(car => {
                // console.log(car);
                return car.dtgUnitId;
            });

        if(downloadUnitIdArr){
            downloadUnitIdArr.map((itemUnitId,idxUnitId) => {
                self.fvmsCommonService.setIsLoading(true);
                let listObservableDriveHis = [];
                this.fileNameZip = "";
                this.fileNameZip += itemUnitId;
                this.fileNameZip += "-";
                let dateYmd = self.datePipe.transform(new Date(),"yyyy-MM-dd-HH-mm-ss");
                this.fileNameZip += dateYmd;

                downloadDateArr.map((itemDate,idxDate) => {
                    let searchInfo = {
                        unitIdArrStr : itemUnitId
                        ,dtgRegDt : itemDate
                    };
                    listObservableDriveHis.push(self.fvmsApiDtgDownloadService.downloadFile(searchInfo));
                });

                forkJoin(listObservableDriveHis)
                    .pipe(takeWhile(() => self.isContinue))
                    .subscribe(listApiResponse => {
                        listApiResponse.map((itemResponse:any,idxResponse) => {
                            if(itemResponse.hasOwnProperty("resultValue") === true){
                                let listDriveHis = itemResponse.resultValue;
                                if(listDriveHis){
                                    listDriveHis.map((itemHisTripInfo,idxHisTripInfo) => {
                                        if(itemHisTripInfo.driveLogList){
                                            let filename = "";
                                            filename += itemHisTripInfo.regDtFilename;
                                            filename += "-";
                                            filename += itemHisTripInfo.dtgCarNoOrg;
                                            filename += "-S-";
                                            filename += self.pad(itemHisTripInfo.tripCnt);
                                            filename += "-";
                                            filename += itemHisTripInfo.dtgDriverLcsNoFilename;
                                            filename += ".txt";

                                            let contentHeader = "";
                                            contentHeader += itemHisTripInfo.dtgModelNo;
                                            contentHeader += itemHisTripInfo.dtgVin;
                                            contentHeader += itemHisTripInfo.dtgCarType;
                                            contentHeader += itemHisTripInfo.dtgCarNo;
                                            contentHeader += itemHisTripInfo.dtgEid;
                                            contentHeader += itemHisTripInfo.dtgDriverLcsNo;
                                            contentHeader += "\r\n";

                                            let contentBody = "";
                                            itemHisTripInfo.driveLogList.map((itemDriveHis,idxDriveHis) => {
                                                contentBody += itemDriveHis.dtgDistDaily;
                                                contentBody += itemDriveHis.dtgDistAccumul;
                                                contentBody += itemDriveHis.dtgRegDt;
                                                contentBody += itemDriveHis.dtgSpeed;
                                                contentBody += itemDriveHis.dtgRpm;
                                                contentBody += itemDriveHis.dtgBrakeYn;
                                                contentBody += itemDriveHis.dtgGpsLng;
                                                contentBody += itemDriveHis.dtgGpsLat;
                                                contentBody += itemDriveHis.dtgGpsDirection;
                                                contentBody += itemDriveHis.dtgAccelX;
                                                contentBody += itemDriveHis.dtgAccelY;
                                                contentBody += itemDriveHis.dtgStatus;
                                                contentBody += "\r\n";
                                            });

                                            let content = contentHeader + contentBody;
                                            let fileBlob = new Blob([iconv.encode(content,"euc-kr")],{ type: "application/octet-stream;"} );

                                            this.listTxtFile.push({
                                                filename:filename
                                                ,file:fileBlob
                                                ,regDt:itemHisTripInfo.regDtFilename
                                                ,carNo:itemHisTripInfo.dtgCarNoOrg
                                            });// Error : body is not a blob or an array buffer
                                            this.changeDetectorRef.detectChanges();
                                        }
                                    });
                                }
                            }
                        });
                    }
                    ,err => {}
                    ,() => {
                        this.changeDetectorRef.detectChanges();
                        self.fvmsCommonService.setIsLoading(false);
                    });
            });
        }
    }

    clickDownloadZip(){
        if(this.listTxtFile && this.fileNameZip){
            this.createZip(this.listTxtFile,this.fileNameZip);
        }
    }

    clickFileDownload(){
        // this.fvmsCommonService.setIsLoading(true);
        let downloadDateArr = [];
        let downloadUnitIdArr = [];
        let self = this;

        for(let key in this.listDateChecked){
            if(this.listDateChecked[key]){
                console.log(key+" : "+this.listDateChecked[key])
                downloadDateArr.push(key);
            }
        }

        downloadUnitIdArr = this.listCarInfo
            .filter(car => car.checked)
            .map(car => {
                console.log(car);
                return car.dtgUnitId;
            });

        if(downloadUnitIdArr){
            downloadUnitIdArr.map((itemUnitId,idxUnitId) => {
                let fileList = [];
                let fileNameZip = "";
                fileNameZip += itemUnitId;
                fileNameZip += "-";
                fileNameZip += new Date().getTime();

                let searchInfo = {
                    unitIdArrStr : itemUnitId
                    ,dtgRegDt : downloadDateArr.join(",")
                };

                self.fvmsApiDtgDownloadService.downloadFile(searchInfo)
                    .pipe(takeWhile(() => self.isContinue))
                    .subscribe(apiResponse => {
                        if(apiResponse.resultValue){
                            let fileDataList = apiResponse.resultValue;
                            fileDataList.map(header => {
                                let filename = "";
                                filename += header.regDtFilename;
                                filename += "-";
                                filename += header.dtgCarNoOrg;
                                filename += "-S-";
                                filename += self.pad(header.tripCnt);
                                filename += "-";
                                filename += header.dtgDriverLcsNoFilename;
                                filename += ".txt";

                                let content = "";
                                content += header.dtgModelNo;
                                content += header.dtgVin;
                                content += header.dtgCarType;
                                content += header.dtgCarNo;
                                content += header.dtgEid;
                                content += header.dtgDriverLcsNo;
                                content += "\r\n";

                                header.driveLogList.map(driveLog => {
                                    content += driveLog.dtgDistDaily;
                                    content += driveLog.dtgDistAccumul;
                                    content += driveLog.dtgRegDt;
                                    content += driveLog.dtgSpeed;
                                    content += driveLog.dtgRpm;
                                    content += driveLog.dtgBrakeYn;
                                    content += driveLog.dtgGpsLng;
                                    content += driveLog.dtgGpsLat;
                                    content += driveLog.dtgGpsDirection;
                                    content += driveLog.dtgAccelX;
                                    content += driveLog.dtgAccelY;
                                    content += driveLog.dtgStatus;
                                    content += "\r\n";
                                });

                                fileList.push({
                                    filename:filename
                                    ,file:new Blob([iconv.encode(content,"euc-kr")],{ type: "application/octet-stream;"} )
                                });// Error : body is not a blob or an array buffer
                            });
                            self.createZip(fileList,fileNameZip);
                        }else{
                            self.fvmsCommonService.setIsLoading(false);
                            console.log(`${itemUnitId} 다운로드 할 데이터가 없습니다.`);
                            return;
                        }
                    });
            });
        }

        // let searchInfo = {
        //     dtgRegDt : downloadDateArr.join(","),
        //     unitIdArrStr: downloadUnitIdArr[0].join(",")
        // }
        // this.fvmsApiDtgDownloadService.downloadFile(searchInfo)
        //     .pipe(takeWhile(() => this.isContinue))
        //     .subscribe(apiResponse => {   
        //         if(apiResponse.resultValue){                  
                    // let fileDataList = apiResponse.resultValue;         
                    // let fileList = [];                   
                    // fileDataList.map(header => {
                    //     let filename = header.regDtFilename+"-"+header.dtgCarNoOrg+"-"+"S"+"-"+this.pad(header.tripCnt)+"-"+header.dtgDriverLcsNoFilename+".txt";
                       
                    //     let content = "";
                    //     content+=header.dtgModelNo+header.dtgVin+header.dtgCarType+header.dtgCarNo+header.dtgEid+header.dtgDriverLcsNo+"\r\n";
                    
                    //     header.driveLogList.map(driveLog =>{
                    //         content+=driveLog.dtgDistDaily+driveLog.dtgDistAccumul+driveLog.dtgRegDt+driveLog.dtgSpeed+driveLog.dtgRpm+driveLog.dtgBrakeYn+driveLog.dtgGpsLng+driveLog.dtgGpsLat+driveLog.dtgGpsDirection+driveLog.dtgAccelX+driveLog.dtgAccelY+driveLog.dtgStatus+"\r\n";
                    //     })

                    //     fileList.push({
                    //         filename:filename,
                    //         file:new Blob([iconv.encode(content,"euc-kr")] , { type: "application/octet-stream;"} )
                    //     });  // Error : body is not a blob or an array buffer                    
                    
                    // })
                    // this.createZip(fileList,this.getZipFileName());
        //         }else{
                    // this.fvmsCommonService.setIsLoading(false);
                    // alert("다운로드 할 데이터가 없습니다.");
                    // return;
        //         }
        //     });
    }
    pad(n) { 
        return n < 10 ? '0' + n : n 
    }
    getZipFileName(){
        let date = new Date();
        return date.getFullYear().toString() + this.pad(date.getMonth() + 1) + this.pad( date.getDate()) + this.pad( date.getHours() ) + this.pad( date.getMinutes() ) + this.pad( date.getSeconds() ) ;
    }

    clickDownTxt(idxListFile:number){
        let itemFile = this.listTxtFile[idxListFile];
        FileSaver.saveAs(itemFile.file,itemFile.filename);
    }

    async createZip(files: any[], zipName: string) {  
        const zip = new JSZip();  
        const name = zipName + '.zip';  
        // tslint:disable-next-line:prefer-for-of  
        for (let i = 0; i < files.length; i++) {  
          const element = files[i];        
          const b: any = new Blob([element.file], { type: 'txt' });  
          zip.file(element.filename, b);  
        }  
        zip.generateAsync({ type: 'blob' }).then((content) => {  
          if (content) {  
            this.fvmsCommonService.setIsLoading(false);
            FileSaver.saveAs(content, name);  
          }  
        });  
      }  
}